import React, { RefObject } from 'react';
import Modal from '@components/modal/modal';
import { Richtext } from '@components/richtext/richtext';
import { UnderlinedButton } from '@components/underlined-button/underlined-button';
import { useModal } from '@hooks/use-modal';

type ResultFormModalProps = {
  modalContent: PvWizardContent['disclaimerText'];
  modalRef: RefObject<HTMLDivElement>;
};

export const OfferFormModal: React.FC<ResultFormModalProps> = ({ modalContent, modalRef }) => {
  const { isOpen, toggle } = useModal();

  return (
    <>
      <UnderlinedButton
        label=""
        onClick={toggle}
        withInfoIcon
        iconSize={24}
        iconFillColor="black60"
      />

      <Modal isOpen={isOpen} close={toggle} modalRef={modalRef} size="full">
        <Richtext document={modalContent} textType="normal" />
      </Modal>
    </>
  );
};
